<template>
  <div class="alert" v-if="notifications.messages">
    Você tem mensagens não lidas no Correio interno.
    <PrimaryButton @click="showMessagesDialog = true">Ver mensagens</PrimaryButton>
  </div>

  <ModalDialog width="400px" v-model="showMessagesDialog" title="Mensagens">
  <table>
        <tbody>
          <tr v-for="(message, key) in messages.data" :key="key" @click="openMessage(message)" :class="message.read ? 'read' : 'not_read'">
            <td>
              {{ message.title }}
              <small class="date d-block">{{ $dateFormat(message.created_at) }}</small>
            </td>
          </tr>
          <tr class="no_result" v-if="!messages.data || (messages.data && !messages.data.length)">
            <td colspan="10">
              Nenhum resultado encontrado
            </td>
          </tr>
        </tbody>
      </table>
    </ModalDialog>

    <ModalDialog width="400px" v-model="showMessageDialog" title="Mensagem">
        <div v-html="messageToLoad.content"></div>
    </ModalDialog>
</template>

<script setup>
import PrimaryButton from '@/components/PrimaryButton.vue';
import { useMessageStore } from '@/stores/MessageStore';
import { storeToRefs } from 'pinia';
import { inject, onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import ModalDialog from './ModalDialog.vue';
import { useAuthStore } from '@/stores/AuthStore';

const route = useRoute();
const authStore = useAuthStore();
const messageStore = useMessageStore();
const { messages } = storeToRefs(messageStore);
const { notifications } = storeToRefs(authStore);

const loader = inject('$loader');
const loading = ref(false);
const showMessagesDialog = ref(false);
const showMessageDialog = ref(false);
const messageToLoad = ref(false);

onMounted(() => {
  if (route.query.search) {
    messageStore.filter.search = route.query.search;
  }

  loadMessages();
});

watch(() => route.query.page, (newPage, oldPage) => {
  if (newPage !== oldPage) {
    window.scrollTo(0, 0);
    loadMessages();
  }
});
 
async function loadMessages() {
  loader.show();
  loading.value = true;
  messageStore.filter.page = parseInt(route.query.page);
  messageStore.filter.read = 0;

  await messageStore.getMessages();

  if(!messageStore.messages.data.length){
    showMessagesDialog.value = false;
  }

  loader.hide();
  loading.value = false;
}


async function openMessage(message) {
    messageToLoad.value = message;
    showMessageDialog.value = true;
    await messageStore.getMessage(message.id);
    await authStore.checkNotifications();
    await loadMessages();
}
</script>


<style scoped>
.alert {
    background-color: #edb139;
    font-weight: 500;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;
}

.date {
  display: block;
  color: #929292;
}

.read {
  color: #717171;
}

.dark .read {
  color: #8f92a7;
}

.not_read td {
  background-color: #fafbff;
  font-weight: 500;
}

.not_read:hover td {
  background-color: #e4e6f0;
}

.dark .not_read td {
  background-color: #232932;
  font-weight: 500;
}

.dark .not_read:hover td {
  background-color: #1e232b;
}

tr {
  cursor: pointer;
}

@media screen and (max-width: 800px){
    .alert {
        display: block;
    }

    .alert button {
        margin-top: 10px;
        width: 100%;
    }
}
</style>